<template>
  <div class="lang-switcher">
    <vh-dropdown @command="handleLangChange" trigger="click">
      <span class="vh-dropdown-link">
        <i class="vh-iconfont vh-language-outline" style="font-size: 16px"></i>
        {{ currentLangText }}
        <i class="vh-icon-arrow-down vh-icon--right"></i>
      </span>
      <vh-dropdown-menu slot="dropdown">
        <vh-dropdown-item
          class="lang-dropdown-item"
          v-for="item in langOptions"
          :command="item.key"
          :key="`lang_${item.key}`"
        >
          {{ item.name }}
        </vh-dropdown-item>
      </vh-dropdown-menu>
    </vh-dropdown>
  </div>
</template>

<script>
  import { langOptions, loadLocale } from '@/common/i18n/index.js';
  export default {
    name: 'LangSwitcher',
    data() {
      return {
        langOptions: langOptions
      };
    },
    computed: {
      currentLangText() {
        const current = this.langOptions.find(item => item.key === this.$i18n.locale);
        return current.name;
      }
    },
    methods: {
      handleLangChange(lang) {
        if (this.$i18n.locale !== lang) {
          loadLocale(lang);

          window.location.reload();
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .lang-switcher {
    .vh-dropdown span {
      color: #888;
    }
    .vh-dropdown i {
      font-size: 12px;
      color: #979797;
    }
    .vh-icon--right {
      margin-left: 0 !important;
    }
  }
  .lang-dropdown-item {
    min-width: 100px;
  }
</style>
